<div *ngIf="nearByPlaces$ | async as nearByPlaces; else placeloading" class="relative">
  <div class="flex gap-3 mt-1 mb-3 mobile:flex-col mobile:mt-3">
    <!-- <div>{{nearByPlaces.length}} places within {{nearByPlacesRange}} miles range</div> -->
     <div class="flex items-center gap-3">
       <div>{{range}} miles range</div>
       <ig-set-range [range]="range" (rangeSet)="setRange($event)"></ig-set-range>
     </div>
    <ig-custom-default-place-category-filter class="mobile:-translate-x-7 translate-y-0.5"
      [isTriggerCalendarReload]="false"></ig-custom-default-place-category-filter>
  </div>

  <div *ngIf="nearByPlaces.length>4" class="flex gap-4 absolute right-0 -top-4 w-[97px] mobile:hidden">
    <mat-icon
      class="!text-[39px] !w-10 !h-10 text-gray-500 rounded-full bg-gray-100 relative z-50 transition-all hover:scale-105"
      [class.!text-gray-200]="isAtStart" [class.cursor-pointer]="!isAtStart" (click)="goLeft()">chevron_left
    </mat-icon>
    <mat-icon
      class="!text-[39px] !w-10 !h-10 text-gray-500 rounded-full bg-gray-100 relative z-50 transition-all hover:scale-105 !ml-0"
      [class.!text-gray-200]="isAtEnd" [class.cursor-pointer]="!isAtEnd" (click)="goRight()">chevron_right
    </mat-icon>
  </div>

  <div *ngIf="!nearByPlaces.length" class="w-1/2 max-h-[260px] mx-auto mobile:mt-0 mobile:w-full">
    <ig-no-content textCls="text-3xl mt-0"></ig-no-content>
  </div>

  <div #nearbyPlacesContainer
       class="flex justify-start items-center p-1 gap-4 scroll-smooth animate-bottom-up overflow-x-hidden overflow-y-hidden mobile:flex-col mobile:max-h-[418px] mobile:overflow-y-auto">
    <div *ngFor="let item of nearByPlaces;let i = index" (click)="goToPlace(item)"
         class="rounded-xl max-w-[calc(25%_-_12px)] min-w-[calc(25%_-_12px)] w-[calc(25%_-_12px)] relative transition-all overflow-y-hidden cursor-pointer hover:scale-[1.03] mobile:w-full mobile:min-w-full mobile:max-w-full mobile:min-h-[180px]">
      <ig-image [src]="item.cover?.source" cls="aspect-[1/1] rounded-xl mobile:aspect-[3/2]"></ig-image>
      <div class="w-full h-1/2 absolute bottom-0 left-0 rounded-2xl bg-gradient-to-b from-transparent to-black">
        <div class="absolute bottom-0 w-full p-4 mobile:pb-2">
          <p class="text-base text-white leading-[1.35rem] mb-1">{{ item.name }}</p>
          <p class="text-sm text-gray-400 leading-[1.35rem] mb-1 hidden mobile:block">
            {{ getDisplayCategory(item) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #placeloading>
  <div class="h-[237px] flex justify-center items-center">
    <ig-spinner mode="block" color="#41abf3"></ig-spinner>
  </div>
</ng-template>
